import React from 'react';
import { Container } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import { useFunctions, useRefs } from '../hooks';
import { Main_wrapperWrapper } from '../wrappers';

import { useLocation } from 'react-router-dom';
import { getLocationParams } from '../util';

// Custom imports:
import { Group, Image, Text, List } from '../components';
import trans_256x128 from '../assets/template/catalog/trans_256x128.png';
import icon_512 from '../assets/icon/icon_512.png';
import { useTranslation } from 'react-i18next';

export const HomeView = () => {
  const { run } = useFunctions();
  const { search, pathname } = useLocation();


  // Custom exports:
	const { t } = useTranslation();

  // Custom functions:

  return (
    <>
      <Helmet>
				<title>{t('home.title')}</title>
      </Helmet>
      <Main_wrapperWrapper>
          
			<Group
				id="homeBody"
				direction="vertical"
				className="w-100 min-h-100vh h-100vh position-relative scrollable" >
				<Group
					id="homeHeader"
					direction="vertical"
					className="w-100 h-auto position-relative p-24px" >
					<Image
						id="homeLogo"
						src={icon_512}
						className="w-164px h-auto align-center position-relative" />
					<Text
						id="homeSlogan"
						tag="h1"
						className="w-100 h-auto position-relative mt-24px text-primary ff-titles text-center" >
						{t('home.homeSlogan')}
					</Text>
				</Group>
				<Group
					id="homeContent"
					direction="vertical"
					className="w-100 h-auto position-relative" >
					<List
						id="productList"
						direction="auto"
						src="@database.products"
						columns={2}
						className="w-100 h-auto align-center position-relative" >
						<Group
							id="productCardWrapper"
							direction="vertical"
							className="w-100 h-auto position-relative p-16px" >
							<Group
								id="productCard"
								direction="vertical"
								className="max-w-400px min-w-300px w-fill h-auto border-primary-dark border-top border-bottom border-start border-end align-center position-relative bg-white" >
								<Image
									id="productBanner"
									fallback={trans_256x128}
									src="banner"
									className="w-100 h-auto position-relative" />
								<Group
									id="productInfo"
									direction="vertical"
									className="w-100 h-auto position-relative p-16px" >
									<Text
										id="productName"
										tag="h3"
										src="name"
										className="w-100 h-auto position-relative text-primary" >
										{t('home.productName')}
									</Text>
									<Text
										id="productDescription"
										src="short_description"
										className="w-100 h-auto position-relative mt-16px text-primary-text" >
										{t('home.productDescription')}
									</Text>
								</Group>
							</Group>
						</Group>
					</List>
				</Group>
			</Group>
      </Main_wrapperWrapper>
    </>
  );
};
